const actions = {
	GET_SINGLE_ANSWER: 'GET_SINGLE_ANSWER',
	GET_SINGLE_ANSWER_SUCCESS: 'GET_SINGLE_ANSWER_SUCCESS',

	CREATE_NEW_SINGLE_ANSWER: 'CREATE_NEW_SINGLE_ANSWER',
	CREATE_NEW_SINGLE_ANSWER_SUCCESS: 'CREATE_NEW_SINGLE_ANSWER_SUCCESS',

	DELETE_SINGLE_ANSWER: 'DELETE_SINGLE_ANSWER',
	DELETE_SINGLE_ANSWER_SUCCESS: 'DELETE_SINGLE_ANSWER_SUCCESS',

	GET_SINGLE_ANSWER_DETAIL: 'GET_SINGLE_ANSWER_DETAIL',
	GET_SINGLE_ANSWER_DETAIL_SUCCESS: 'GET_SINGLE_ANSWER_DETAIL_SUCCESS',

	UPDATE_SINGLE_ANSWER_DETAIL: 'UPDATE_SINGLE_ANSWER_DETAIL',
	UPDATE_SINGLE_ANSWER_DETAIL_SUCCESS: 'UPDATE_SINGLE_ANSWER_DETAIL_SUCCESS',

	READING_LOADING_FALSE: 'READING_LOADING_FALSE',
	//#region CRUD

	getSingleAnswer: (model) => ({
		type: actions.GET_SINGLE_ANSWER,
		payload: { model },
	}),

	getSingleAnswerDetail: (id) => ({
		type: actions.GET_SINGLE_ANSWER_DETAIL,
		payload: { id },
	}),

	// createQuesReadAloud: (body, cbSuccess, cbError) => ({
	// 	type: actions.CREATE_NEW_SINGLE_ANSWER,
	// 	payload: { body },
	// 	cbSuccess,
	// 	cbError,
	// }),

	// updateReadAloudDetail: (model, cbSuccess, cbError) => ({
	// 	type: actions.UPDATE_SINGLE_ANSWER_DETAIL,
	// 	payload: { model },
	// 	cbSuccess,
	// 	cbError,
	// }),

	// deleteReadAloud: (id, cbSuccess, cbError) => ({
	// 	type: actions.DELETE_SINGLE_ANSWER,
	// 	payload: { id },
	// 	cbSuccess,
	// 	cbError,
	// }),
};

export default actions;
